import React from 'react';

import type { SlotContextProps } from './types/slots.types';

const SlotsContext = React.createContext<null | SlotContextProps>(null);

export default SlotsContext;
